import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textHumanize'
})
export class TextHumanizePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return (value || '')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase() );
  }

}
